import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'

// evertel
import { Col, IconLink, Row, Text } from '@evertel/web/ui'
import { APIDataDocumentSchema, APIDataDocumentSchemaCategory } from '@evertel/types'
import { DocumentIcon } from '@evertel/web/document'
import { OptionsMenu } from './OptionsMenu'
import { DrawerNavDropdownLink } from '../elements/DrawerNavItemDropdown'

interface DocumentCategoryOptionProps {
    title?: string
    schemas: APIDataDocumentSchema[]
    category?: APIDataDocumentSchemaCategory
    isVisible: boolean
    onClick?: () => void
    onCloneSchema?: (schema: APIDataDocumentSchema) => void
    canManage: boolean
    filter?: string
}

export const DocumentCategoryOption: React.FC<DocumentCategoryOptionProps> = observer(({
    title,
    schemas,
    category,
    isVisible,
    onClick,
    onCloneSchema,
    canManage,
    filter = ''
}) => {

    const filteredSchemas = useMemo(() => {
        if (!schemas || !filter) return schemas
        return schemas.filter(schema =>
            schema.name?.toLowerCase().includes(filter.toLowerCase())
        )
    }, [schemas, filter])

    return (
        <DrawerNavDropdownLink
            id={`dropdown-section-${category?.id}`}
            label={category ? category.name as string : (title ?? 'All')}
            isOpen={isVisible && !!filteredSchemas?.length}
        >
            {filteredSchemas?.map((schema: APIDataDocumentSchema, index) =>
                <div
                    key={index}
                    className="position-relative"
                >
                    <IconLink
                        to={onClick ? `/everdocs/add/${schema.id}` : undefined}
                        key={schema.id}
                        className="d-flex align-items-center drawer-item-link"
                        onClick={onClick}
                        tabIndex={canManage ? -1 : 0}
                        aria-describedby={`dropdown-section-${category?.id}`}
                        data-drawer-nav="category"
                    >
                        <Row valign="center" style={{width: 220}}>
                            <DocumentIcon
                                schema={schema}
                                className="me-3"
                            />
                            <Text
                                color="gray300"
                                className="text-truncate"
                                // in case a long schema name is truncated
                                title={schema.name}
                            >
                                {schema.name}
                            </Text>
                        </Row>
                    </IconLink>
                    <div className="drawer-options-holder" >
                        {(canManage) &&
                                <OptionsMenu
                                    onCreate={onClick}
                                    onClone={onCloneSchema}
                                    schema={schema}
                                    canManage={canManage}
                                />
                        }
                    </div>
                </div>
            )}
            {(!filteredSchemas?.length) &&
                    <Row className="picker-item">
                        <Text
                            style={{fontStyle: 'italic'}}>
                            No documents in this category
                        </Text>
                    </Row>
            }
        </DrawerNavDropdownLink>
    )
})
